import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import DatePicker from "react-datepicker";
import Select, { StylesConfig } from "react-select";
import { TimePicker, TimePickerProps } from "antd";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from "dayjs";
import TextField from '../../../../../core/common/textFields/TextField';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { useCreateAppointmentResultMutation, useUpdateAptResultMutation } from '../../../../../services/EndPointsApis';


const AppointmentsResultSidebar = ({ activityTogglePopup, viewOnly, closeSidebar, aptResultbyId, TriggerAptResult, selectedIndividualCheckboxId, InquiryId, isEditing }: any) => {

    dayjs.extend(customParseFormat);
    const onChangeStart: TimePickerProps['onChange'] = (time, timeString) => {
        const formattedTime = time ? dayjs(time).format("h:mm A") : '';
        formik3.setFieldValue('startTime', formattedTime);
    };
    const onChangeEnd: TimePickerProps['onChange'] = (time, timeString) => {
        const formattedTime = time ? dayjs(time).format("h:mm A") : '';
        formik3.setFieldValue('endTime', formattedTime);
    };
    const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
    const handleDateChange = (date: Date | null) => {
        setSelectedDate(date);
    };
    const [selectedDate1, setSelectedDate1] = useState<Date | null>(new Date());
    const handleDateChange1 = (date: Date | null) => {
        setSelectedDate1(date);
    };

    const [updateId, setUpdateId] = useState(0);
    const id = selectedIndividualCheckboxId;
    const AptId = id[0];
    const [aptId, setApiId] = useState(AptId)


    //Create Result Api

    const [createAppointmentResult, { data, isError, error, isSuccess, isLoading }] =
        useCreateAppointmentResultMutation();
    //Update Result Api
    const [updateAppointmentResult, { data: updatedData, isError: updatedIsError, error: UpdateError, isSuccess: updateIsSuccess, isLoading: UpdateIsLoading }] =
        useUpdateAptResultMutation();

    const resultId = aptResultbyId?.result?.resultId;
    //Formik
    const initialValues = {
        appointmentId: aptId,
        recNumber: "",
        lst_SelAppointmentType: {
            id: 2,
            value: aptResultbyId?.result?.lst_SelAppointmentType?.value
        },
        lst_Progress: [
            {
                id: 0,
                value: "",
                checked: true
            }
        ],
        lst_AppointmentType: [
            {
                id: 0,
                value: ""
            }
        ],
        resultId: 0,
        startTime: "",
        endTime: "",
        resultNote: ""
    }
    const formik3 = useFormik({
        initialValues,
        // validationSchema: contactSchema,
        onSubmit: (values) => {
            if (resultId !== -1) {
                updateAppointmentResult({ ...values })
            } else {

                createAppointmentResult({ ...values });
            }
        },
        enableReinitialize: true,
    });
    const { resetForm } = formik3;

    useEffect(() => {

        if (!aptResultbyId && activityTogglePopup) {
            TriggerAptResult({ LeadInquiryId: InquiryId, AppointmentId: aptId, Id: -1 })
        }
        else if (aptResultbyId && activityTogglePopup) {
            TriggerAptResult({ LeadInquiryId: InquiryId, AppointmentId: aptId, Id: aptResultbyId?.result?.resultId })
        }
    }, [aptResultbyId, activityTogglePopup])

    useEffect(() => {
        setApiId(AptId)
    }, [selectedIndividualCheckboxId, AptId])

    useEffect(() => {
        if (resultId === -1 && isSuccess) {
            toast.success(data?.message);
            resetForm();
            closeSidebar()
            // navigate('/contacts')
        }
        if (resultId !== -1 && updateIsSuccess) {
            toast.success(updatedData?.message);
            resetForm();
            closeSidebar()
        }

    }, [isSuccess, updateIsSuccess]);


    useEffect(() => {
        if (aptResultbyId?.result && Object.keys(aptResultbyId?.result).length > 0) {
            setUpdateId(aptResultbyId?.result?.appointmentId);
            formik3.setValues({ ...aptResultbyId?.result });
        } else {
            setUpdateId(0);
            // resetForm();
        }
    }, [aptResultbyId, updateId]);

    const handleCheckboxCange = (id: number) => {
        formik3.setFieldValue(
            "lst_Progress",
            formik3.values.lst_Progress.map(item =>
                item.id === id ? { ...item, checked: !item.checked } : item
            )
        );
    };

    const handleSubmit = (e: any) => {
        e.preventDefault()
        formik3.handleSubmit()

    }
    // const handleCheckboxChange = (id: number, newChecked: boolean) => {
    //     const currentProgress = formik3.values.lst_Progress;

    //     const updatedProgress = currentProgress.map((item: any) =>
    //         item.id === id ? { ...item, checked: newChecked } : item
    //     );

    //     formik3.setFieldValue('lst_Progress', updatedProgress);
    // };
    const handleCheckboxChange = (id: number, checked: boolean) => {
        const currentProgress = formik3.values.lst_Progress;

        // Toggle only the specific item's checked state
        const updatedProgress = currentProgress.map((item: any) =>
            item.id === id ? { ...item, checked } : item
        );
        // Update Formik's state with the new progress
        formik3.setFieldValue('lst_Progress', updatedProgress);

    };

    return (
        <div className={activityTogglePopup ? "toggle-popup sidebar-popup" : "toggle-popup"}>
            <div className="sidebar-layout">
                <div className="sidebar-header">
                    <h4>Appointment Results</h4>
                    <Link to="#" className="sidebar-close toggle-btn" onClick={closeSidebar}>
                        <i className="ti ti-x" />
                    </Link>
                </div>
                <div className="toggle-body">
                    <div className="toggle-height">
                        <div className="pro-create">
                            <form onSubmit={formik3.handleSubmit}>
                                <div className="row">
                                    <h5 className='text-gray mb-3'>Submit Appointment Results</h5>
                                    <div className="col-md-12 mt-2">
                                        <TextField
                                            label=" Appointment Type"
                                            type="text"
                                            value={aptResultbyId?.result?.lst_SelAppointmentType?.value}
                                            disabled
                                        />
                                    </div>
                                    <div className="col-md-12 mt-2">
                                        <TextField
                                            label="Appointment"
                                            type="text"
                                            value={aptResultbyId?.result?.appointmentRecNumber}
                                            disabled
                                        />
                                    </div>
                                    <div className='col-md-12'>
                                        <label className='input-label'>Progress</label>
                                        <div className='row'>
                                            {aptResultbyId?.result?.lst_Progress.map((item: any, index: number) => (
                                                <div className="col-md-6" key={item.id}>
                                                    <div className="d-flex gap-2">
                                                        <label className="checkboxs">
                                                            {item.value}
                                                            <input
                                                                type="checkbox"
                                                                checked={formik3.values.lst_Progress[index]?.checked}
                                                                // value={item.checked}
                                                                onChange={(e) => handleCheckboxChange(item.id, e.target.checked)}
                                                                disabled={viewOnly}
                                                            />
                                                            <span className="checkmarks mt-1" />
                                                        </label>
                                                    </div>
                                                </div>
                                            ))}

                                            <div className='col-md-6'>
                                                {/* {aptResultbyId?.result?.lst_Progress?.map((progressItem: any) => (
                                                    <div className='d-flex gap-2' key={progressItem.id}>
                                                        <label className="checkboxs">
                                                            {progressItem.value}
                                                            <input
                                                                type="checkbox"
                                                                checked={progressItem.checked}
                                                                onChange={(e) => handleChange(progressItem.id, 'checked', e.target.checked, formik3.setFieldValue, formik3.values)}
                                                            />
                                                            <span className="checkmarks mt-1" />
                                                        </label>
                                                    </div>
                                                ))} */}
                                            </div>
                                        </div>
                                        {/* <div className='row mt-2'>
                                            <div className='col-md-6'>
                                                <div className='d-flex gap-2'>
                                                    <label className="checkboxs">
                                                        Fresh Appointment - Is Run (Positive)
                                                        <input
                                                            type="checkbox"

                                                        // {...formik.getFieldProps("isSubNewsLetter")}
                                                        />
                                                        <span className="checkmarks mt-1" />
                                                    </label>
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className='d-flex gap-2'>
                                                    <label className="checkboxs">
                                                        Fresh Appointment - Is Canceled (Negative)                                                    <input
                                                            type="checkbox"

                                                        // {...formik.getFieldProps("isSubNewsLetter")}
                                                        />
                                                        <span className="checkmarks mt-1" />
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='row mt-2'>
                                            <div className='col-md-6'>
                                                <div className='d-flex gap-2'>
                                                    <label className="checkboxs">
                                                        Fresh Appointment - Is No Show (Negative)
                                                        <input
                                                            type="checkbox"

                                                        // {...formik.getFieldProps("isSubNewsLetter")}
                                                        />
                                                        <span className="checkmarks mt-1" />
                                                    </label>
                                                </div>
                                            </div>
                                            <div className='col-md-6'>
                                                <div className='d-flex gap-2'>
                                                    <label className="checkboxs">
                                                        Fresh Appointment - Measure Completed
                                                        <input
                                                            type="checkbox"

                                                        // {...formik.getFieldProps("isSubNewsLetter")}
                                                        />
                                                        <span className="checkmarks mt-1" />
                                                    </label>
                                                </div>
                                            </div>
                                        </div> */}
                                        {/* <div className='row mt-2'>
                                            <div className='col-md-6'>
                                                <div className='d-flex gap-2'>
                                                    <label className="checkboxs">
                                                        Fresh Appointment - Parties On Same Page
                                                        <input
                                                            type="checkbox"

                                                        // {...formik.getFieldProps("isSubNewsLetter")}
                                                        />
                                                        <span className="checkmarks mt-1" />
                                                    </label>
                                                </div>
                                            </div>
                                        </div> */}
                                    </div>
                                    <div className="col-md-6 mt-2">
                                        <label className="input-label">
                                            Start Time <span className="text-danger">*</span>
                                        </label>
                                        <TimePicker
                                            placeholder="Select Time"
                                            className="form-control datetimepicker-time"
                                            onChange={onChangeStart}
                                            // value={aptResultbyId?.result?.startTime}
                                            defaultOpenValue={dayjs("12:00 AM", "h:mm A")}
                                            format="h:mm A"
                                            use12Hours
                                            disabled={viewOnly}
                                            value={formik3.values?.startTime && dayjs(formik3.values.startTime, "h:mm A").isValid()
                                                ? dayjs(formik3.values.startTime, "h:mm A")
                                                : null}
                                        />
                                    </div>
                                    <div className="col-md-6 mt-2">
                                        <label className="input-label">
                                            End Time <span className="text-danger">*</span>
                                        </label>
                                        <TimePicker
                                            placeholder="Select Time"
                                            className="form-control datetimepicker-time"
                                            onChange={onChangeEnd}
                                            // value={aptResultbyId?.result?.endTime}
                                            defaultOpenValue={dayjs("12:00 AM", "h:mm A")}
                                            format="h:mm A"
                                            use12Hours
                                            disabled={viewOnly}
                                            value={formik3.values?.endTime && dayjs(formik3.values.endTime, "h:mm A").isValid()
                                                ? dayjs(formik3.values.endTime, "h:mm A")
                                                : null}
                                        />
                                    </div>
                                    {/* <div className="col-md-6 mt-2">
                                    <label className="input-label">
                                        Duration<span className="text-danger"> *</span>
                                    </label>
                                    <Select
                                        styles={customStyles}
                                        className="select"
                                        options={options3}
                                    />
                                </div> */}
                                    <div className="col-md-12 mt-2">
                                        <div className="form-wrap">
                                            <label className="input-label">
                                                Result Notes <span className="text-danger">*</span>
                                            </label>
                                            <textarea
                                                className="form-control"
                                                rows={4}
                                                placeholder='Type....'
                                                {...formik3.getFieldProps("resultNote")}
                                                disabled={viewOnly}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        <div className="submit-button text-end">
                            <button type='button' className="btn btn-light sidebar-close" onClick={closeSidebar}>
                                Cancel
                            </button>
                            {viewOnly ? '' :
                                <button
                                    type='submit'
                                    className="btn btn-primary"
                                    onClick={handleSubmit}
                                >
                                    {resultId !== -1 ? "Update" : "Save"}
                                </button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AppointmentsResultSidebar;
